export default __webpack_public_path__ + "static/8-e33dbc7750ff718b01e0866c7e0eceba.webp";